<template>
  <div class="change-pwd">
    <nf-form-wrap :on-save-btn-click="handleSaveBtnClick" save-btn-text="提交修改">
      <div slot="content">
        <el-form
          ref="ruleForm"
          label-position="top"
          label-width="80px"
          :size="$store.state.element.elBtnSize"
          class="enterprise-add-content"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="item2.label">
                <span class="required-color">*</span>手机号
                <el-input
                  v-model="username"
                  type="text"
                  clearable
                  disabled
                  autocomplete="new-password"
                  maxlength="11"
                  placeholder="请输入手机号"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="item2.label">
                <span class="required-color">*</span>验证码
                <el-input
                  v-model="code"
                  type="text"
                  autocomplete="new-password"
                  clearable
                  maxlength="6"
                  placeholder="请输入验证码"
                />
                <el-button class="code-btn" :loading="codeLoading" type="primary">
                  {{ codeText }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="item2.label">
                <span class="required-color">*</span>新密码
                <el-input
                  v-model="params.newPassword"
                  type="password"
                  maxlength="20"
                  clearable
                  show-password
                  autocomplete="new-password"
                  placeholder="请输入新密码"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item prop="item2.label">
                <span class="required-color">*</span>重复密码
                <el-input
                  v-model="params.reNewPassword"
                  type="password"
                  maxlength="20"
                  show-password
                  autocomplete="new-password"
                  clearable
                  placeholder="请再次输入新密码"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </nf-form-wrap>
  </div>
</template>
<script>
import { getCookie } from '@/utils';
export default {
  data() {
    return {
      event: 'resetPwd',
      params: {
        // 手机号
        phone: '',
        // 验证码
        code: '',
        // 新密码
        newPassword: '',
        // 确认新密码
        reNewPassword: '',
        password: '',
      },
      username: '',
    };
  },
  created() {
    let loginUserName = getCookie('loginUserName');
    this.username = loginUserName;
  },
  beforeRouteEnter() {
    let localtion = window.location;
    let { origin, host } = localtion;
    let url = origin.replace(host.split('.')[0], 'cloud') + '/user';
    localtion.href = url;
  },
};
</script>
<style lang="scss" scoped>
.code-btn {
  position: absolute;
  bottom: 1px;
  right: 0;
}
.change-pwd /deep/footer .foot-btn {
  left: 0;
}
</style>
